import * as RasaInput from '../../components/rasa-input'
import * as GlobalTypes from '../../types'
import * as Constants from './constants'
import * as Types from './types'

export const addEventModalStateValid = (state: Types.ModalData): boolean => {
  let result = !RasaInput.validateEmailList(RasaInput.trimList(RasaInput.splitString(state.to_email))).invalid &&
  !RasaInput.validatePresent(state.name).invalid &&
  !RasaInput.validatePresent(state.community_identifier).invalid &&
  !RasaInput.validatePresent(state.schedule_type).invalid

  if (state.schedule_type === 'calendar') {
    result = result && !RasaInput.validateTime(state.time).invalid
  }
  return result
}

export const getScheduleTypes = (reportingType: string[]): GlobalTypes.Option[] => {
  const options = reportingType.map((schedType) =>
  ({description: Constants.ReportTypes[schedType], key: schedType}))
  options.unshift(
    {
    description: Constants.PLEASE_SELECT_A_SCHEDULE_TYPE,
    key: Constants.PLEASE_SELECT_A_SCHEDULE_TYPE,
    })
  return options
}

export const shouldShowAddReport = (state: Types.State) => {
  const existingReports = state.data.map((r) => r.event_type)
  for (const SupportedReport of Constants.SupportedReports) {
    if (existingReports.indexOf(SupportedReport) < 0) {
      return true
    }
  }
  return false
}

export const fetchQueryParamsFromState = (state: Types.State): Types.QueryState => {
  return {
    filter: state.search ? state.search.term : '',
    limit: Constants.SERVER_PAGE_SIZE,
    pageNumber: state.page.pageNumber,
    sortBy: state.view.sort && state.view.sort.length > 0 ? state.view.sort[0].field : 'created',
    sortDir: state.view.sort && state.view.sort.length > 0 ? state.view.sort[0].dir : Constants.SORT_BY.Desc,
  }
}

export const queryParamsToState = (params: any) => {
  const newFilter = Object.keys(params).includes('search') ?
        {
          filter: params.search,
        }
        : {}

  const sort = Object.keys(params).includes('sortBy') ?
        {
          sort: [{
            dir: params.sortDir,
            field: params.sortBy,
          }],
        }
        : {}

  return {...params,
    ...newFilter,
    ...sort}
}



// WEBPACK FOOTER //
// ./src/pages/admin-reports/utils.ts